import { db } from './config';
import { collection, getDocs, query, where } from 'firebase/firestore';

// Get count of pending appointments
export const getPendingAppointmentsCount = async () => {
  try {
    const appointmentsCollection = collection(db, 'appointments');
    const pendingQuery = query(appointmentsCollection, where('status', '==', 'pending'));
    const querySnapshot = await getDocs(pendingQuery);
    
    return querySnapshot.size;
  } catch (error) {
    console.error('Error getting pending appointments count:', error);
    return 0;
  }
};

// Get count of unread messages
export const getUnreadMessagesCount = async () => {
  try {
    const messagesCollection = collection(db, 'contactMessages');
    const unreadQuery = query(messagesCollection, where('read', '==', false));
    const querySnapshot = await getDocs(unreadQuery);
    
    return querySnapshot.size;
  } catch (error) {
    console.error('Error getting unread messages count:', error);
    return 0;
  }
};

// Get count of pending testimonials
export const getPendingTestimonialsCount = async () => {
  try {
    const testimonialsCollection = collection(db, 'testimonials');
    const pendingQuery = query(testimonialsCollection, where('approved', '==', false));
    const querySnapshot = await getDocs(pendingQuery);
    
    return querySnapshot.size;
  } catch (error) {
    console.error('Error getting pending testimonials count:', error);
    return 0;
  }
};

// Get all notification counts at once
export const getAllNotificationCounts = async () => {
  try {
    const pendingAppointments = await getPendingAppointmentsCount();
    const unreadMessages = await getUnreadMessagesCount();
    const pendingTestimonials = await getPendingTestimonialsCount();
    
    return {
      pendingAppointments,
      unreadMessages,
      pendingTestimonials,
      total: pendingAppointments + unreadMessages + pendingTestimonials
    };
  } catch (error) {
    console.error('Error getting all notification counts:', error);
    return {
      pendingAppointments: 0,
      unreadMessages: 0,
      pendingTestimonials: 0,
      total: 0
    };
  }
};